"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EqualityHelper = void 0;
class EqualityHelper {
    static shallowObjEquals(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) {
            return false;
        }
        for (const key in obj1) {
            if (obj1.hasOwnProperty(key) && obj2.hasOwnProperty(key)) {
                if (obj1[key] !== obj2[key]) {
                    return false;
                }
            }
            else {
                if (obj1.hasOwnProperty(key) || obj2.hasOwnProperty(key)) {
                    return false;
                }
            }
        }
        return true;
    }
    ;
}
exports.EqualityHelper = EqualityHelper;
//# sourceMappingURL=equality-helper.js.map